import { lazy, Suspense } from "react";
import { useSearchParams } from "react-router-dom";
import { urlRoutes } from "../constants/page";

const ViewAssetModal = lazy(() => import("./ViewAssetModal"));
const ViewVendorModal = lazy(() => import("./ViewVendorModal"));
const ViewLocationModal = lazy(() => import("./ViewLocationModal"));
const ViewUserModal = lazy(() => import("./ViewUserModal"));

export default function GlobalModals() {
  const [searchParams] = useSearchParams();
  const assetId = searchParams.get("asset");
  const vendorId = searchParams.get("vendor");
  const locationId = searchParams.get("location");
  const userId = searchParams.get("user");

  return (
    <Suspense fallback={null}>
      {!!assetId && window.location.pathname !== urlRoutes.form && (
        <ViewAssetModal open />
      )}
      {!!vendorId && <ViewVendorModal open />}
      {!!locationId && <ViewLocationModal open />}
      {!!userId && <ViewUserModal open />}
    </Suspense>
  );
}
